var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("manage-ticket", {
    attrs: {
      application: _vm.deTicketApplications.FINANZAS,
      modules: _vm.modules,
      "on-download": _vm.onDownloadHandler,
      "read-only": _vm.readOnly,
      "reference-number-types": _vm.referenceNumberTypes,
      "save-ticket": _vm.saveUserCase,
      "ticket-data": _vm.ticketData,
      user: _vm.fullProfile,
      "validate-reference-number": _vm.validateReferenceNumber
    },
    on: { "update-references": _vm.fetchReferenceNumberTypes }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }